import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";

import Button from "@components/Button";
import WrongAnswerPopup, {
  wrongAnswerPopupSpringSettings,
} from "../../../../../components/WrongAnswerPopup";
import DOMPurify from "dompurify";
import { useTransition } from "@react-spring/web";

export default function Textarea({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [inputValues, setInputValues] = useState({});
  const [wrongAnswerPopupSettings, setWrongAnswerPopupSettings] = useState({
    visible: false,
    forElement: null,
  });

  const handleInputChange = (index, value) => {
    setInputValues((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  const CheckAnswers = () => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;
    const selectedAnswerIdent = inputValues[currentQuestion] || "";

    setAnswers((prevAnswers) => {
      const isQuestionAlreadyAnswered = prevAnswers.find(
        (answer) => answer.question_ident === currentQuestionIdent
      );

      if (
        !isQuestionAlreadyAnswered &&
        (gameQuestionsQuery.content[currentQuestion].correctAnswer === null ||
          selectedAnswerIdent ===
            gameQuestionsQuery.content[currentQuestion].correctAnswer)
      ) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: inputValues[0],
          },
        ];
      }
      return prevAnswers;
    });
  };

  const handleNextButtonClick = () => {
    CheckAnswers();

    setCurrentQuestion((prevQuestion) => {
      const nextQuestion = prevQuestion + 1;
      return nextQuestion;
    });

    setInputValues((prev) => {
      const newValues = { ...prev };
      delete newValues[currentQuestion];
      console.log("Input values after deletion:", newValues);
      return newValues;
    });

    if (gameQuestionsQuery.answersNumber === answers.length) {
      console.log("All answers submitted:", answers);
      sendAnswers();
    }
  };

  const wrongAnswerPopupTransition = useTransition(
    wrongAnswerPopupSettings.visible,
    wrongAnswerPopupSpringSettings
  );

  return (
    <section className={`game-page quiz-mechanics-textarea ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
            <div className={`answer-content ${ident}`}>
              <div className="answers-wrapper">
                {gameQuestionsQuery.content[currentQuestion].answers.map(
                  ({ answer }, index) => (
                    <textarea
                      key={index}
                      className="answer-textarea"
                      value={inputValues[index] || ""} // Pobieranie wartości
                      onChange={(e) => handleInputChange(index, e.target.value)} // Ustawianie wartości
                      placeholder=""
                      maxLength={1000}
                    />
                  )
                )}
                {/* <div className="limit">
                  {" "}
                  {inputValues[currentQuestion]?.length || 0} / 1000
                </div> */}
              </div>
            </div>
            <a
              href={gameQuestionsQuery.content[currentQuestion]?.questDisLink}
              target="_blank"
              rel="noopener noreferrer"
              className="answer-dis"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]?.questDis),
              }}
            ></a>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              inputValues[currentQuestion] ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              <StickyContent>
                {wrongAnswerPopupTransition(
                  (style, item) =>
                    item && (
                      <WrongAnswerPopup
                        visible={wrongAnswerPopupSettings}
                        onClose={() =>
                          setWrongAnswerPopupSettings((prev) => ({
                            ...prev,
                            visible: false,
                          }))
                        }
                        style={style}
                      />
                    )
                )}
                <div className="desktop-buttons">
                  <Button action={handleNextButtonClick}>
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton
          action={handleNextButtonClick}
          additionalElement={wrongAnswerPopupTransition(
            (style, item) =>
              item && (
                <WrongAnswerPopup
                  visible={wrongAnswerPopupSettings}
                  onClose={() =>
                    setWrongAnswerPopupSettings((prev) => ({
                      ...prev,
                      visible: false,
                    }))
                  }
                  style={style}
                />
              )
          )}
        >
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
